import React from "react";
import "./ourbus.css";
// import ourbusineeg1 from "../OURBUSINESS/OURBUSINESS--IMAGES/OURBUSINESSG1.png";
import ourbusineeg1 from "../OURBUSINESS/OURBUSINESS--IMAGES/logo.png";
import { Link } from "react-router-dom";
import Nav from "../nav";
import MetaData from "../MetaData";

export default function Ourbusiness() {
  return (
    <>
      <MetaData title="Our Business | GLOCRE Private Limited" />
      <Nav />

      <body className="container-fluid">
        <section className="empowering-global-section-procureg">
          <div className="container">
            <div className="row">
              <div
                className="col-lg-6 empowering-global-left-procureg p-0"
                style={{
                  height: "477px",
                  width: "630px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={ourbusineeg1} className="img-fluid w-75" />
              </div>
              <div className="col-lg-6 p-0 mt-2 empowering-global-right-procureg">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">
                      Empowering Global Trade: Simplifying Industrial
                      Transactions with Glocre
                    </h5>
                    <p class="card-text">
                      Glocre is a global e-commerce platform that connects
                      buyers and sellers, simplifying transactions with fast
                      shipping, reliable support, and opportunities for
                      consumers to expand their reach and ensure seamless,
                      high-quality experiences.
                    </p>
                    <Link to="/becomeseller">
                      <button className="mt-3">Get started</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="our-business-section-procureg">
          <div className="container">
            <div className="our-business-contents-procureg">
              <h3>OUR BUSINESS AT GLOCRE</h3>
              <p>
                Glocre connects global buyers and sellers with seamless,
                efficient e - commerce solutions.
              </p>
            </div>
          </div>

          <div className="global-buyer-contents-procureg">
            <div class="card " style={{backgroundColor:"#f5f5f5"}}>
              <div class="global-buyer-full-contents-procureg container">
                <div className="row">
                  <div className="global-buyer-right-contents-procureg">
                    <div className="row m-2">
                      <div className="col-lg-4">
                        <div class="card" style={{ height: "270px" }}>
                          <div class="card-body">
                            <h5 class="card-title">Our Strategy</h5>
                            <p class="card-text">
                              To combine industry expertise and technology to
                              build a transparent, scalable B2B eCommerce
                              ecosystem that supports new products while
                              addressing sourcing challenges and reducing global
                              wastage of excess and non‑moving inventory.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div class="card" style={{ height: "270px" }}>
                          <div class="card-body">
                            <h5 class="card-title">Our Goal</h5>
                            <p class="card-text">
                              To enable enterprises to launch, source, and
                              optimize products efficiently, maximizing value
                              through reliable supply networks and responsible
                              inventory utilization.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div class="card" style={{ height: "270px" }}>
                          <div class="card-body">
                            <h5 class="card-title">What We Do</h5>
                            <p class="card-text">
                              We operate an industry-focused B2B eCommerce
                              platform for new products and surplus industrial
                              inventory, connecting buyers with verified
                              suppliers to enable smarter sourcing, vendor
                              development, and sustainable supply chains.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="d-flex justify-content-center align-items-center text-center empowering-global-section-procureg">
          <div
            className="col-lg-9"
            style={{ backgroundColor: "#f5f5f5", borderRadius: "15px" }}
          >
            <div className="empowering-global-right-procureg">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">
                    Glocal sourcing made smart & simple
                  </h5>
                  <p class="card-text">
                    Glocre Private Limited is a scalable B2B eCommerce platform
                    for global and local procurement, built by experienced
                    directors with strong ancestral business foundations and
                    extensive global MNC exposure. We address large, persistent
                    inefficiencies in industrial sourcing by enabling new
                    product commercialization and value recovery from surplus,
                    non‑moving inventory, improving quality, cost, delivery
                    reliability, and localization through a transparent,
                    technology‑led business model.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="our-core-section-procureg mt-5 mb-5">
          <div className="container">
            <div className="our-core-heading-procureg">
              <h3>OUR CORE VALUES</h3>
            </div>

            <div className="row justify-content-center g-4">
              <div className="col-lg-6">
                <div
                  className="our-core-sub-section-procureg p-4"
                  style={{ backgroundColor: "#fff", borderRadius: "15px" }}
                >
                  <h3>Experience‑Driven Innovation</h3>
                  <p>
                    While Glocre is a new venture, we are firmly rooted in
                    decades of combined industry, technology, and business
                    experience. Backed by directors with strong ancestral
                    business backgrounds and global MNC exposure, we innovate
                    with clarity, responsibility and real world understanding.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="our-core-sub-section-procureg p-4"
                  style={{ backgroundColor: "#fff", borderRadius: "15px" }}
                >
                  <h3>Transparency & Trust</h3>
                  <p>
                    We believe sustainable businesses are built on transparent
                    processes, honest pricing, and clear communication. Trust is
                    the foundation of every relationship we build across
                    customers, suppliers and partners.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="our-core-sub-section-procureg p-4"
                  style={{ backgroundColor: "#fff", borderRadius: "15px" }}
                >
                  <h3>Industry‑First Mindset</h3>
                  <p>
                    Our solutions are designed for real industrial needs. From
                    new product sourcing to managing surplus and non‑moving
                    inventory, we focus on practicality, reliability and
                    measurable value for the industry.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="our-core-sub-section-procureg p-4"
                  style={{ backgroundColor: "#fff", borderRadius: "15px" }}
                >
                  <h3>Responsible Growth & Waste Reduction</h3>
                  <p>
                    We are committed to reducing global industrial waste by
                    unlocking value from excess and non‑moving inventory,
                    supporting reuse, redistribution and sustainable supply
                    chains.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="our-core-sub-section-procureg p-4"
                  style={{ backgroundColor: "#fff", borderRadius: "15px" }}
                >
                  <h3>Quality, Cost & Delivery Excellence</h3>
                  <p>
                    We uphold uncompromising standards in quality, cost
                    competitiveness, and delivery reliability addressing the
                    most critical challenges faced by global enterprises today.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="our-core-sub-section-procureg p-4"
                  style={{ backgroundColor: "#fff", borderRadius: "15px" }}
                >
                  <h3>Collaboration & Long‑Term Partnerships</h3>
                  <p>
                    We grow together with our ecosystem manufacturers,
                    suppliers, technology partners, and buyers building
                    long-term relationships that create shared success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </body>
    </>
  );
}
